import apiConfig from '../config/api';

const getToken = () => localStorage.getItem('AccessToken');
export const sendMail = (email) =>
    fetch(`${apiConfig.apiUri}api/mail/send`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
            'auth-api-key-8d7f51df': '3af2f24a-7b8b-49c1-afc1-9b95d29ad33e',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(email),
    });
